<template>
  <div>
    <div class="row py-2">
      <div class="col-12">
        <router-link :to="{name: 'researcher.bookmark_folders'}" class="t-sm text-decoration-none">
          <i class="fa fa-navicon t-secondary mr-2" /> Back to all bookmarks
        </router-link>
      </div>
    </div>
    <div class="row">

      <div :class="{'col-md-12': index !== 'research_group', 'col-md-9': isLoaded && index === 'research_groups'}">
        <div class="card mb-4">
          <div v-if="isBookmarkFolderLoaded && bookmarkFolder" class="card-body py-3 position-relative">
            <bookmark-item
              :researcher="researcher"
              :user="user"
              :bookmarkFolder="bookmarkFolder"
              showTags
              noRedirect
            />
          </div>

          <div v-else class="card-body py-3">
            <spinner :containerClass="`width--50px min-height--150px`" />
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <search-container
          v-if="isBookmarkFolderLoaded && !isEmpty(searchFilterObject)"
          :isWithFixedFilter="searchFilterObject"
          :bookmarkFolder="bookmarkFolder"
        />

        <!-- no items in the set -->
        <div v-if="isBookmarkFolderLoaded && isEmpty(searchFilterObject)" class="card">
          <div class="card-body py-3">
            <h3>
              Bookmark folders
              <span v-if="canEdit" class="t-xs t-regular"><br />to keep track and organize your research</span>
            </h3>

            <p v-if="canEdit" class="mb-0 mt-4 text-center">
              <i class="fa fa-plus d-block t-secondary"></i>
              <router-link :to="{ name: 'searchHome'}" class="t-sm">Start adding items from the search</router-link>
            </p>

            <p v-else class="mb-0 mt-4 text-center t-sm">
              No items added to this set
            </p>
          </div>
        </div>

        <!-- loading set -->
        <div v-if="!isBookmarkFolderLoaded" class="card">
          <div class="card-body py-3">
            <spinner :containerClass="`width--50px min-height--150px`" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from '@/components/shared/Spinner'
import SearchContainer from '@/containers/Search'

import BookmarkItem from '@/components/user/bookmark_folder/Item'

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'researcherBookmarkFolderShow',
  components: {
    Spinner,
    SearchContainer,
    BookmarkItem
  },
  props: {
    isLoaded: {
      type: Boolean,
      default: false
    },
    researcher: {
      type: Object,
      required: true
    },
    user: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      error: null,
      isBookmarkFolderLoaded: false,
      searchFilterObject: {},
      index: 'publications',
      bookmarkFolder: {}
    }
  },
  beforeRouteUpdate (to, from, next) {
    if (to.params.bookmark_folder !== from.params.bookmark_folder) this.fetch(to.params.bookmark_folder)
    this.checkOpenModal(to.query)
    next()
  },
  metaInfo () {
    return {
      titleTemplate: this.isBookmarkFolderLoaded ? `${this.bookmarkFolder.name} | AcademicLabs` : `${this.getFullName(this.researcher)} | AcademicLabs`,
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: this.bookmarkFolder.description ? this.stripTags(this.bookmarkFolder.description) : ''
        }
      ]
    }
  },
  mounted () {
    if (this.$route.params.category) this.index = this.$route.params.category
    this.fetch(this.$route.params.bookmark_folder)
    this.checkOpenModal(this.$route.query)
  },
  computed: {
    ...mapGetters({
      folderById: 'bookmarks/folderById'
    }),
    canEdit () {
      return this.$can.edit('researcher', this.user.rw_access)
    }
  },
  methods: {
    ...mapActions('bookmarks', [
      'getBookmarkFolderBySlugValue'
    ]),
    fetch (slugValue) {
      this.isBookmarkFolderLoaded = false
      // Fetch folder info from API
      this.getBookmarkFolderBySlugValue(slugValue).then(bm => {
        // Get up to date folder from the Vuex store
        this.bookmarkFolder = this.folderById(bm.id)
        // Check which category we need to navigate to, depending on whichever category has a count first
        if (this.bookmarkFolder.count > 0) {
          const [index] = this.getMostRelevantIndex(this.bookmarkFolder.categories, 'publications')
          this.index = index
        }
        this.searchFilterObject = {
          key: 'bookmark_folders',
          index: this.index,
          global: false,
          value: `${bm.id}` // convert int to string
        }
        this.isBookmarkFolderLoaded = true

        if (this.$route.query.success) {
          this.success = `Successfully accepted invite to join ${bm.name}.`
          this.$router.replace({ name: this.$route.name, params: this.$route.params })
        }
      }).catch(err => {
        this.error = this.handleError(err)
        this.isBookmarkFolderLoaded = !this.isEmpty(this.error)
      })
    }
  }
}
</script>
